export default "__VITE_PUBLIC_ASSET__ef7269b1__"